import { render, staticRenderFns } from "./ProductClickRegions.vue?vue&type=template&id=4b0d74a2"
import script from "./ProductClickRegions.vue?vue&type=script&lang=js"
export * from "./ProductClickRegions.vue?vue&type=script&lang=js"
import style0 from "./ProductClickRegions.vue?vue&type=style&index=0&id=4b0d74a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports